import { render, staticRenderFns } from "./DeathTreatmentDataviz.vue?vue&type=template&id=9797951c&scoped=true&"
import script from "./DeathTreatmentDataviz.vue?vue&type=script&lang=js&"
export * from "./DeathTreatmentDataviz.vue?vue&type=script&lang=js&"
import style0 from "./DeathTreatmentDataviz.vue?vue&type=style&index=0&id=9797951c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9797951c",
  null
  
)

export default component.exports